import { SortDirection } from "@tanstack/react-table";
import { DownIcon, SortIcon, UpIcon } from "components/icons";

export const getSortIcon = (direction: SortDirection | false) => {
  if (!direction) return <SortIcon />;
  return direction === "asc" ? <UpIcon /> : <DownIcon />;
};
